import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { telemetry } from '../services/telemetryService';

/** Fires an App Insights page view on each route path change. No-op when telemetry is disabled. */
export function usePageViewTracking(): void {
  const location = useLocation();
  useEffect(() => {
    telemetry.trackPageView(location.pathname);
  }, [location.pathname]);
}
